module.exports = __webpack_public_path__ + "6074db3ea37a6cae0462862514889822.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-files-mobile.png
// module id = 3636
// module chunks = 0